import { render, staticRenderFns } from "./page-data.vue?vue&type=template&id=22ce6c00&"
import script from "./page-data.vue?vue&type=script&lang=js&"
export * from "./page-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports